import React, { Component } from "react";
import { Modal, Checkbox, message, Tooltip } from "antd";
import { getSelectedHospital, Privilege, getConsultationHospitalList } from "@/request/api";
import { requestErrorLog } from '@/common/util'

// const { Option } = Select;

class HospitalModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			//所有的会诊医院
			CONSULATION_HOSPITAL: [],
			applyHospital: [],
			consulationGroup: [],
			applyGroup: [],
			//选中的会诊医院
			selectedHospital: [],
			selectedApplyHospital: [],
			selectedApplyGroup: "",
			selectedConsulationGroup: ""
		};
	}
	handleCloseApplyModal = () => {
		this.props.onRef(false);
	};
	componentDidMount() {
		this.getSelectedHospital();
		this.getHospitalListGroup();
	}

	//获取医院列表
	getHospitalListGroup = () => {
		const {
			rowData: { FIRST_GROUP_CODE, SECOND_GROUP_CODE, IS_APPLY_HOSPITAL, HOSPITAL_CODE }
		} = this.props;
		//会诊医院列表和分组
		if (IS_APPLY_HOSPITAL) {
			this.getConsulationList(FIRST_GROUP_CODE, SECOND_GROUP_CODE, HOSPITAL_CODE);
		}
		//申请医院列表和分组
		// if (IS_CONSULATION_HOSPITAL) {
		// 	this.getApplyList(DATA_GROUP, HOSPITAL_CODE);
		// }
	};

	getConsulationList = (FIRST_GROUP_CODE, SECOND_GROUP_CODE, HOSPITAL_CODE) => {
		getConsultationHospitalList(FIRST_GROUP_CODE, SECOND_GROUP_CODE).then((res) => {
			if (res && res.Status === 1) {
				let list = this.formatHospital(res.Result || [], HOSPITAL_CODE);
				this.setState({
					CONSULATION_HOSPITAL: list
				});
			} else {
				requestErrorLog('', '权限管理-医院管理-获取会诊医院报错', 0, true)
			}
		});
	};

	// getApplyList = (DATA_GROUP, HOSPITAL_CODE) => {
	// 	getHospitalListGroup("ApplyHospitals", DATA_GROUP).then((res) => {
	// 		if (res && res.Status === 1) {
	// 			let list = this.formatHospital(res.Result.hospitallist, HOSPITAL_CODE);
	// 			this.setState({
	// 				applyHospital: list,
	// 				applyGroup: res.Result.group || []
	// 			});
	// 		}
	// 	});
	// };

	consulationChange = (item) => {
		this.setState({
			selectedHospital: item
		});
		console.log(item);
	};

	applyHospitalChange = (item) => {
		this.setState({
			selectedApplyHospital: item
		});
		console.log(item);
	};

	applyGroupChange = (group) => {
		this.setState({
			selectedApplyGroup: group
		});
	};

	consulationGroupChange = (group) => {
		this.setState({
			selectedConsulationGroup: group
		});
	};

	//添加会诊权限
	handleHospitalSubmit = () => {
		let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
		const { rowData } = this.props;
		const { selectedHospital, CONSULATION_HOSPITAL, selectedApplyHospital, applyHospital } = this.state;
		let conInfo = [];
		let applyinfo = [];
		selectedHospital.forEach((item) => {
			let elem = CONSULATION_HOSPITAL.find((val) => item === val.HOSPITAL_CODE);
			if (elem) {
				conInfo.push({
					CONSULTATION_HOSPITAL_CODE: elem.HOSPITAL_CODE,
					CONSULTATION_HOSPITAL_NAME: elem.HOSPITAL_NAME,
					APPLY_HOSPITAL_CODE: rowData.HOSPITAL_CODE,
					APPLY_HOSPITAL_NAME: rowData.HOSPITAL_NAME,
					IS_DEFAULT: 0
				});
			}
		});
		selectedApplyHospital.forEach((item) => {
			let elem = applyHospital.find((val) => item === val.HOSPITAL_CODE);
			if (item) {
				applyinfo.push({
					CONSULTATION_HOSPITAL_CODE: rowData.HOSPITAL_CODE,
					CONSULTATION_HOSPITAL_NAME: rowData.HOSPITAL_NAME,
					APPLY_HOSPITAL_CODE: elem?.HOSPITAL_CODE,
					APPLY_HOSPITAL_NAME: elem?.HOSPITAL_NAME,
					IS_DEFAULT: 0
				});
			}
		});

		let params = {
			Type: "AddPrivilege", // 会诊权限
			HOSPITAL_CODE: rowData.HOSPITAL_CODE,
			USER_UID: userInfo.USER_UID,
		};
		Privilege(params, conInfo).then((res) => {
			if (res && res.Status === 1) {
				if (res.Result === -1) return message.error("未查到该医院信息");
				if (res.Result === -2) return message.error("医院分组有变动，请稍后重试");
				if (res.Result === -3) return message.error("未查到会诊医院信息");
				if(res.Result === -4) return message.error("所选医院有不附和条件的分组");
				this.handleCloseApplyModal();
				message.success("添加成功");
			} else {
				requestErrorLog('', '权限管理-医院管理-添加会诊权限报错', 0, true)
			}
		});
	};

	//获取选中的会诊医院
	getSelectedHospital = () => {
		const { rowData } = this.props;
		let params = {
			Type: "Remote",
			hospital_Code: rowData.HOSPITAL_CODE
		};
		getSelectedHospital(params).then((res) => {
			if (res && res.Status === 1) {
				let selectedHospital = [];
				let selectedApplyHospital = [];

				let consulation = res.Result?.RemoteHospital || [];
				let apply = res.Result?.ConsultationHospital || [];

				consulation.forEach((item) => {
					selectedHospital.push(item.CONSULTATION_HOSPITAL_CODE);
				});

				apply.forEach((item) => {
					selectedApplyHospital.push(item.APPLY_HOSPITAL_CODE);
				});
				this.setState({
					selectedApplyHospital,
					selectedHospital
				});
			} else {
				requestErrorLog('', '权限管理-医院管理-获取选中的会诊医院报错', 0, true)
			}
		});
	};

	//屏蔽到当前医院
	formatHospital = (list = [], code) => {
		console.log(list);
		list = [...list];
		let index = list.findIndex((item) => item.HOSPITAL_CODE === code);
		if (index > -1) {
			list.splice(index, 1);
		}
		return list;
	};

	render() {
		const { visible, rowData } = this.props;
		const { CONSULATION_HOSPITAL } = this.state;
		return (
			<Modal
				title="医院权限"
				visible={visible}
				onOk={this.handleHospitalSubmit}
				onCancel={this.handleCloseApplyModal} // 右上角的关闭按钮
			>
				<div style={{ color: "#000" }}>
					<div>
						<p style={{ fontWeight: "bold" }}>
							{rowData.IS_APPLY_HOSPITAL ? "申请医院" : ""}
							{rowData.IS_APPLY_HOSPITAL && rowData.IS_CONSULATION_HOSPITAL ? "、" : ""}
							{rowData.IS_CONSULATION_HOSPITAL ? "会诊医院" : ""}
						</p>
						<div style={{ marginTop: "10px", background: "#fff", lineHeight: "30px" }}>
							<p>医院编码：{rowData.HOSPITAL_CODE}</p>
							<p>医院名称：{rowData.HOSPITAL_NAME}</p>
						</div>
					</div>
					{/* {rowData.IS_CONSULATION_HOSPITAL ? (
						<div style={{ marginTop: "20px" }}>
							<div style={{ display: "flex", alignItem: "center" }}>
								<p style={{ fontWeight: "bold" }}>申请医院</p>
								<Select
									style={{ marginLeft: 10, width: 200 }}
									placeholder="请选择分组"
									value={this.state.selectedApplyGroup}
									onChange={this.applyGroupChange}>
									<Option value={""}>全部</Option>
									{this.state.applyGroup.map((item) => (
										<Option key={item.DATA_GROUP} value={item.DATA_GROUP}>
											{item.DATA_GROUP}
										</Option>
									))}
								</Select>
							</div>
							<div style={{ background: "#fff" }} className="checkGroupBox">
								<Checkbox.Group
									style={{ marginTop: "10px" }}
									onChange={this.applyHospitalChange}
									value={this.state.selectedApplyHospital}>
									{applyHospital.length > 0 &&
										applyHospital.map((item) => (
											<Tooltip key={item.HOSPITAL_CODE} placement="topLeft" title={item.HOSPITAL_NAME}>
												<Checkbox
													value={item.HOSPITAL_CODE}
													style={{
														display:
															this.state.selectedApplyGroup === item.DATA_GROUP || this.state.selectedApplyGroup === ""
																? "block"
																: "none"
													}}>
													{item.HOSPITAL_NAME}
												</Checkbox>
											</Tooltip>
										))}
								</Checkbox.Group>
							</div>
						</div>
					) : null} */}

					{rowData.IS_APPLY_HOSPITAL ? (
						<div style={{ marginTop: "20px" }}>
							<div style={{ display: "flex", alignItems: "center" }}>
								<p style={{ fontWeight: "bold" }}>会诊医院</p>
								{/* <Select
									style={{ marginLeft: 10, width: 200 }}
									placeholder="请选择分组"
									value={this.state.selectedConsulationGroup}
									onChange={this.consulationGroupChange}>
									<Option value={""}>全部</Option>
									{this.state.consulationGroup.map((item) => (
										<Option key={item.DATA_GROUP} value={item.DATA_GROUP}>
											{item.DATA_GROUP}
										</Option>
									))}
								</Select> */}
							</div>
							<div style={{ background: "#fff" }} className="checkGroupBox">
								<Checkbox.Group
									style={{ marginTop: "10px" }}
									// options={CONSULATION_HOSPITAL}
									onChange={this.consulationChange}
									value={this.state.selectedHospital}>
									{CONSULATION_HOSPITAL.length > 0 &&
										CONSULATION_HOSPITAL.map((item) => (
											<Tooltip key={item.HOSPITAL_CODE} placement="topLeft" title={item.HOSPITAL_NAME}>
												<Checkbox
													value={item.HOSPITAL_CODE}
													style={{
														display:
															this.state.selectedConsulationGroup === item.DATA_GROUP ||
																this.state.selectedConsulationGroup === ""
																? "block"
																: "none"
													}}>
													{item.HOSPITAL_NAME}
												</Checkbox>
											</Tooltip>
										))}
								</Checkbox.Group>
							</div>
						</div>
					) : null}
				</div>
			</Modal>
		);
	}
}

export default HospitalModal;
